import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaptopCode, faGraduationCap, faHeadphonesSimple, faBookOpen } from '@fortawesome/free-solid-svg-icons';
import {
  faWindows as fabFaWindows,
  faApple as fabFaApple,
  faLinux as fabFaLinux,
  faAndroid as fabFaAndroid,
} from '@fortawesome/free-brands-svg-icons';

import DlcBadge from 'Components/Label/DlcBadge';
import Drm from 'Components/ProductInfo/Drm';

const PlatformIcons = ({ hit, colorOverride }) => {
  const OS = hit.operating_systems || [];
  OS.sort().reverse();

  let validDrm = '';
  let filteredDrm = [];
  if (hit && hit.drm) filteredDrm = hit.drm.filter(d => d !== 'voucher' && d !== 'drm free');

  if (filteredDrm.length === 1) validDrm = filteredDrm[0];

  return (
    <div className="PlatformIcons">
      {validDrm &&
        <Drm drmType={validDrm} className="PlatformIcons__drm" colorOverride={colorOverride} />
      }

      {!validDrm && (hit.display_type === 'comic-bundle' || hit.display_type === 'comic') &&
        <div className="PlatformIcons__bundleType">
          <FontAwesomeIcon icon={faBookOpen} />
          <div className="PlatformIcons__bundleType__text">
            <FormattedMessage id="platformicons.comic-bundle" defaultMessage="Comic" />
          </div>
        </div>
      }

      {!validDrm && hit.display_type === 'graphic-novel' &&
        <div className="PlatformIcons__bundleType">
          <FontAwesomeIcon icon={faBookOpen} />
          <div className="PlatformIcons__bundleType__text">
            <FormattedMessage id="platformicons.graphic-novel" defaultMessage="Graphic Novel" />
          </div>
        </div>
      }

      {!validDrm && (hit.display_type === 'book-bundle' || hit.display_type === 'book') &&
        <div className="PlatformIcons__bundleType">
          <FontAwesomeIcon icon={faBookOpen} />
          <div className="PlatformIcons__bundleType__text">
            <FormattedMessage id="platformicons.book-bundle" defaultMessage="eBook" />
          </div>
        </div>
      }

      {!validDrm && (hit.display_type === 'elearning-bundle' || hit.display_type === 'elearning') &&
        <div className="PlatformIcons__bundleType">
          <FontAwesomeIcon icon={faGraduationCap} />
          <div className="PlatformIcons__bundleType__text">
            <FormattedMessage id="platformicons.elearning-bundle" defaultMessage="eLearning" />
          </div>
        </div>
      }

      {!validDrm && (hit.display_type === 'audio-bundle' || hit.display_type === 'audio') &&
        <div className="PlatformIcons__bundleType">
          <FontAwesomeIcon icon={faHeadphonesSimple} />
          <div className="PlatformIcons__bundleType__text">
            <FormattedMessage id="platformicons.audio" defaultMessage="Audio" />
          </div>
        </div>
      }

      {!validDrm && hit.display_type === 'software-bundle' &&
        <div className="PlatformIcons__bundleType">
          <FontAwesomeIcon icon={faLaptopCode} />
          <div className="PlatformIcons__bundleType__text">
            <FormattedMessage id="platformicons.software" defaultMessage="Software" />
          </div>
        </div>
      }

      {(validDrm === 'utalk' || !isEmpty(OS)) &&
        <div className="PlatformIcons__osIcons">
          {OS && OS.map(os =>
            <span className="PlatformIcons__osIcon" key={os}>
              {os === 'windows' &&
                <FontAwesomeIcon icon={fabFaWindows} />
              }
              {os === 'mac' &&
                <FontAwesomeIcon icon={fabFaApple} />
              }
              {os === 'linux' &&
                <FontAwesomeIcon icon={fabFaLinux} />
              }
            </span>,
          )}
          {validDrm === 'utalk' &&
            <span className="PlatformIcons__osIcon">
              <FontAwesomeIcon icon={fabFaAndroid} />
            </span>
          }
        </div>
      }

      {hit.display_type === 'dlc' &&
        <DlcBadge />
      }
    </div>
  );
};

PlatformIcons.propTypes = {
  hit: PropTypes.object,
  colorOverride: PropTypes.string,
};

PlatformIcons.defaultProps = {
  hit: {},
  colorOverride: null,
};

export default PlatformIcons;
